export default {
  CURRENT (state, value) {
    state.list = value
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        firstName: value.firstName,
        lastName: value.lastName,
        alarmEmails: value.alarmEmails,
        email: value.email
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_ADD (state, value) {
    state.list.push({
      id: value.id,
      firstName: value.firstName,
      lastName: value.lastName,
      alarmEmails: value.alarmEmails,
      email: value.email
    })
  }
}
